import React from "react";
import { Switch } from "react-router-dom";
import VendorPrivateRoute from "../../Layout/VendorPrivateRoute";
import HeaderLayoutRoute from "../../Layout/HeaderLayoutRoute";
import Dashboard from "../../vendor/DashBoard/Dashboard";
import MySubscriptions from "../../vendor/MySubscriptions";
import ReqACall from "../../vendor/Signup/ReqACall";
import Signup from "../../vendor/Signup/Signup";
import { RoutesUrl } from "../constents";

const VendorRoutes = () => {
  return (
    <Switch>
      <VendorPrivateRoute
        exact
        path={RoutesUrl.VendorDashboard}
        component={Dashboard}
      />
      <VendorPrivateRoute
        exact
        path={RoutesUrl.VendorMyApps}
        component={MySubscriptions}
      />
      <HeaderLayoutRoute
        exact
        path={RoutesUrl.VendorReqACall}
        component={ReqACall}
      />
      <HeaderLayoutRoute
        exact
        path={RoutesUrl.VendorSignup}
        component={Signup}
      />
      ;
    </Switch>
  );
};

export default VendorRoutes;
